/*
 * @Description: Flutter 对接沙滩说
 * @Author: gaolei
 * @Date: 2024-09-18
 * @LastEditTime: 2024-09-23 10:40:57
 * @LastEditors: gaolei
 */

import { useAuthStore } from '@/stores/login'
// import { updateUserInfo } from '@/utils/userInfo'
import 'vant/lib/index.css'
import dsBridge from 'dsbridge'
import { loading } from '@/utils/loading'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import CryptoJS from 'crypto-js'
import router from '@/router'
import { useUsersStore } from '@/stores/users'
import { wexinJump } from './weixinBusiness'

// 判断是否是Native App内嵌沙滩说
export const isSandsTalkNativeApp = window.navigator.userAgent.indexOf('sandsTalkNativeApp') > -1

export const AppVersion = window.navigator.userAgent.indexOf('AppVersion') > -1

// console.log(isSandsTalkNativeApp, 'isSandsTalkNativeApp')

// 在项目中创建一个全局声明文件（如：global.d.ts）
declare global {
  interface Window {
    jt?: {
      callHandler: (handler: string, params: {}) => Promise<any>
    }
    previous?: () => boolean
  }
}

declare global {
  interface Window {
    jtJsBridge?: {
      jtH5CallNativeApi: (request: any, callback: (responseData: any) => void) => void
    }
  }
}

const callNative = async (request: { method: string; data?: any }): Promise<any> => {
  return new Promise((resolve, reject) => {
    dsBridge.call('jtH5CallNativeApi', request, (responseData) => {
      if (responseData && typeof responseData === 'string') {
        try {
          const parsedResponse = JSON.parse(responseData)
          resolve(parsedResponse)
        } catch (error) {
          resolve(responseData)
        }
      } else {
        resolve(responseData)
      }
    })
  })
}

const callNative2 = async (request: { method: string; data?: any }): Promise<any> => {
  return new Promise((resolve, reject) => {
    dsBridge.call('jtH5CallNativeApi', request, (responseData) => {
      resolve(responseData)
    })
  })
}

// 获取签名
function getSign(params: any, secret: any, timestamp: any) {
  const paramsJson = params ? JSON.stringify(params, Object.keys(params).sort()) : 'N_V'
  const stringToSign = `${paramsJson}\n${timestamp}\n${secret}`

  // 将 stringToSign 直接作为 HMAC 密钥使用，确保与 Java 逻辑一致
  const hmac = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, CryptoJS.enc.Utf8.parse(stringToSign))
  const signData = hmac.finalize(CryptoJS.lib.WordArray.create([]))

  // 返回 Base64 编码的签名
  return CryptoJS.enc.Base64.stringify(signData)
}

// 泰国外场 获取沙滩说token
export const sandsTalkNativeLogin = async () => {
  loading.show()
  try {
    // 平台检测
    const u = navigator.userAgent
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1

    let getUserInfor = {} as {
      source?: string
      sourceType?: string
      jumpType?: string
      jumpModuleId?: string
      customTemplateId?: string
      lang?: string,
      empNo?: string
    }

    if (isAndroid) {
      // Android 平台使用 dsBridge 直接调用
      const res = await dsBridge.call('SandsTalkUserInfoChannel')
      getUserInfor = JSON.parse(res)
    } else {
      if (AppVersion) {
        // iOS 平台使用 callNative 方法  新代码
        const request = { method: 'SandsTalkUserInfoChannel' }
        const res = await callNative2(request)
        // console.log(res, 'res====11111')
        let parsedRes
        try {
          parsedRes = typeof res === 'string' ? JSON.parse(res) : res
        } catch (error) {
          parsedRes = res
        }
        getUserInfor = parsedRes.data
        // console.log(getUserInfor, 'getUserInfor====2222')
      } else {
        // 兼容旧代码
        const res = await dsBridge.call('SandsTalkUserInfoChannel')
        getUserInfor = JSON.parse(res)
      }

    }

    let appId = ''
    // let appSecret = ''
    let signSecret = ''
    let language = ''
    let identifierType = ''

    // 准备请求参数
    const timestamp = Date.now()
    // 泰国外场
    if (getUserInfor.source === 'ThOutfield') {
      // console.log('泰国外场==========')
      appId = 'th_outfield_app' // 由沙滩说提供
      // appSecret = 'ryWJumN32wAuSapwl8' // 由沙滩说提供
      signSecret = 'ryWJumN32wAuSapwl8'
      identifierType = 'account'
      language = getUserInfor.lang || 'th'
      localStorage.setItem('lang', language || 'th')
      // 存储原生给的用户信息数据到 localStorage
      localStorage.setItem('SandsTalkUserInfo', JSON.stringify(getUserInfor))
    }

    const noce = uuidv4()

    const params = {
      appId,
      // appSecret,
      identifierType: identifierType || '',
      identifierValue: getUserInfor.empNo || '',
      noce,
      timestamp,
      // appUniqueId
    }

    // 生成签名
    const sign = getSign(params, signSecret, timestamp)

    // 构造最终的请求数据
    const finalRequestData = {
      appId,
      // appSecret,
      identifierType: identifierType || '',
      identifierValue: getUserInfor.empNo || '',
      noce,
      sign,
      timestamp,
      // appUniqueId
    }

    // alert(JSON.stringify(finalRequestData))

    // 发送请求
    try {
      const { data } = await axios.post(
        `${process.env.VUE_APP_API_URL}/sands-user/api/v1/auth/authorization-token`,
        JSON.stringify(finalRequestData),
        {
          headers: {
            'Content-Type': 'application/json',
            'accept-language': language
          }
        }
      )

      // alert(JSON.stringify(data))

      if (data.code === 1) {
        loading.hide()
        const authStore = useAuthStore()
        authStore.setAccessToken(data.data.access_token)
        localStorage.setItem('sandsTalkToken', data.data.access_token)
        localStorage.setItem('sandsTalkTenantId', data.data.tenantId || '1000')
        const usersStore = useUsersStore()
        const { setCollegeId } = usersStore
        setCollegeId(data.data.collegeId)
        if (getUserInfor.sourceType === 'training') {
          // 培训列表
          router.replace('/myTraining')
        } else {
          router.replace('/')
        }
        return data.data.access_token
      } else {
        const authStore = useAuthStore()
        authStore.setAccessToken('')
        localStorage.removeItem('sandsTalkToken')
        loading.hide()
        sandsTalkShowToast(data.msg)
        destroyH5()
      }
    } catch (error) {
      const authStore = useAuthStore()
      authStore.setAccessToken('')
      localStorage.removeItem('sandsTalkToken')
      loading.hide()
      sandsTalkShowToast(error + '')
      destroyH5()
    }
  } catch (error) {
    const authStore = useAuthStore()
    authStore.setAccessToken('')
    localStorage.removeItem('sandsTalkToken')
    loading.hide()
    destroyH5()
    console.error('获取Token失败:', error)
    return {}
  }
}

// 越南外场 免登
export const sandsTalkVnNativeLogin = async () => {
  loading.show()

  // 确保 window.jt 赋值，每次进入页面都检查
  if (!window.jt && window.flutter_inappwebview) {
    window.jt = window.flutter_inappwebview
    setTimeout(() => {
      sandsTalkVnNativeLogin()
    }, 200)
  }

  try {
    let getUserInfor = {} as {
      source?: string
      sourceType?: string
      jumpType?: string
      jumpModuleId?: string
      customTemplateId?: string
      lang?: string
    }
    let appId = 'vn_outfield_app'
    let signSecret = 'o0TN7VkoyfPjSZlJFs'
    let identifierType = 'empNo'
    let identifierValue = ''
    let language = ''

    // 检查是否是越南原生环境
    // console.log(window.jt, 'window.jt')
    if (window.jt && window.jt.callHandler) {
      try {
        const res = await window.jt.callHandler('getMetaInfo', {})
        if (res?.data) {
          getUserInfor = res.data
          console.log('越南原生环境获取到的用户信息:', getUserInfor)
        } else {
          console.error('getMetaInfo 返回格式不正确:', res)
        }
        localStorage.removeItem('SandsTalkUserInfo')
        localStorage.setItem('SandsTalkUserInfo', JSON.stringify(getUserInfor))
      } catch (error) {
        console.error('调用 getMetaInfo 失败:', error)
      }
    }

    // 获取用户信息
    const userInfoData = JSON.parse(localStorage.getItem('SandsTalkUserInfo') || '{}')
    identifierValue = userInfoData.psCode || userInfoData.userInfo.staffNo || ''
    language = getLangKey(userInfoData.lange) || 'vi'
    localStorage.setItem('lang', getLangKey(userInfoData.lange) || 'vi')

    const timestamp = Date.now()
    const noce = uuidv4()

    const params = {
      appId,
      identifierType,
      identifierValue,
      noce,
      timestamp,
    }

    const sign = getSign(params, signSecret, timestamp)

    const finalRequestData = {
      ...params,
      sign
    }

    try {
      const { data } = await axios.post(
        `${process.env.VUE_APP_API_URL}/sands-user/api/v1/auth/authorization-token`,
        JSON.stringify(finalRequestData),
        {
          headers: {
            'Content-Type': 'application/json',
            'accept-language': language
          }
        }
      )

      if (data.code === 1) {
        loading.hide()
        const authStore = useAuthStore()
        authStore.setAccessToken(data.data.access_token)
        localStorage.setItem('sandsTalkToken', data.data.access_token)
        localStorage.setItem('sandsTalkTenantId', data.data.tenantId || '1000')

        const usersStore = useUsersStore()
        usersStore.setCollegeId(data.data.collegeId)
        // console.log('getUserInfor====app传递的数据', getUserInfor);
        // console.log('getUserInfor====app传递的数据参数', getUserInfor?.sourceType, getUserInfor?.jumpType, getUserInfor?.jumpModuleId);
        if (getUserInfor?.sourceType === 'notice' && getUserInfor?.jumpType) {
          // 消息
          wexinJump(getUserInfor?.jumpType, getUserInfor?.jumpModuleId, getUserInfor?.customTemplateId || '')
        } else {
          router.replace('/')
        }
        return data.data.access_token
      } else {
        handleAuthError(data.msg)
      }
    } catch (error) {
      handleAuthError(error)
    }
  } catch (error) {
    handleAuthError(error)
  }
}

// 越南外场 统一处理鉴权失败
const handleAuthError = (message: any) => {
  const authStore = useAuthStore()
  authStore.setAccessToken('')
  localStorage.removeItem('sandsTalkToken')
  loading.hide()
  showNativeToast(String(message))
}

//  泰国外场 沙滩说下载H5链接  (文件下载)
export const nativeDownloadH5Url = async (url: string) => {
  const u = navigator.userAgent
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
  if (isAndroid) {
    // 泰国外场 Android 平台使用 dsBridge
    await dsBridge.call('downloadStudyFile', url)
  } else {
    if (AppVersion) {
      // 泰国外场 IOS 平台使用 callNative 
      const request = { method: 'downloadStudyFile', url }
      await callNative(request)
    } else {
      await dsBridge.call('downloadStudyFile', url)
    }
  }
}

/**
 * @Description 泰国外场 销毁H5页面（H5调用原生）
 * 使用场景：底层页面返回至app、未获取到登录信息等
 */
export const destroyH5 = async () => {
  // console.log('销毁H5')
  const u = navigator.userAgent
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1

  if (isAndroid) {
    // 泰国外场 Android 平台使用 dsBridge
    dsBridge.call('finish')
  } else {
    if (AppVersion) {
      // 泰国外场 IOS 平台使用 callNative 
      const request = { method: 'FinishPageChannel' }
      await callNative(request)
    } else {
      dsBridge.call('finish')
    }
  }
}

export const sandsTalkShowToast = async (msg: string) => {
  const u = navigator.userAgent
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
  if (isAndroid) {
    // 泰国外场 Android 平台使用 dsBridge
    await dsBridge.call('sandsTalkShowToast', msg)
  } else {
    if (AppVersion) {
      // 泰国外场 IOS 平台使用 callNative 
      const request = { method: 'sandsTalkShowToast', msg }
      await callNative(request)
    } else {
      await dsBridge.call('sandsTalkShowToast', msg)
    }

  }
}

// 泰国外场打开新页面
export const sandsTalkNativeUrl = async (url: string) => {
  const u = navigator.userAgent
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
  if (isAndroid) {
    // 泰国外场 Android 平台使用 dsBridge
    dsBridge.call('goToNativeLoadUrl', url)
  } else {
    if (AppVersion) {
      // 泰国外场 IOS 平台使用 callNative 
      const request = { method: 'goToNativeLoadUrl', url }
      await callNative(request)
    } else {
      dsBridge.call('goToNativeLoadUrl', url)
    }
  }
}

// 越南外场打开新页面
export const sandsTalkVnNativeUrl = async (url: string) => {
  if (!window.jt && window.flutter_inappwebview) {
    window.jt = window.flutter_inappwebview
  }
  if (window.jt && window.jt.callHandler) {
    try {
      const response = await window.jt.callHandler('openWebPage', { url: url, isuseSafeArea: true })
    } catch (error) {
      console.error('调用 openWebPage 失败:', error)
    }
  }
}

// 越南外场 跳转h5支付页面  原生中拿不到微信SDK，所以无法实现微信支付
// 也可以打开外部链接下载
export const sandsTalkVnNativeLauncherUrl = async (url: string) => {
  if (!window.jt && window.flutter_inappwebview) {
    window.jt = window.flutter_inappwebview
  }
  if (window.jt && window.jt.callHandler) {
    try {
      await window.jt.callHandler('urlLauncher', { url: url })
    } catch (error) {
      console.error('调用 urlLauncher 失败:', error)
    }
  }
}

// 越南外场 标题
export const sandsTalkVnNativeTitle = async (name: string) => {
  if (!window.jt && window.flutter_inappwebview) {
    window.jt = window.flutter_inappwebview
  }
  if (window.jt && window.jt.callHandler) {
    try {
      await window.jt.callHandler('setTitle', { title: name, isShow: true })
    } catch (error) {
      console.error('调用 urlLauncher 失败:', error)
    }
  }
}

// 越南弹出提示
export const showNativeToast = async (message: string) => {
  if (!window.jt && window.flutter_inappwebview) {
    window.jt = window.flutter_inappwebview
  }
  if (window.jt && window.jt.callHandler) {
    try {
      const response = await window.jt.callHandler('showToast', { msg: message })
      // console.log('原生 Toast 调用结果:', response)
      window.jt.callHandler('routerBack', {})
    } catch (error) {
      console.error('调用 showToast 失败:', error)
    }
  } else {
    console.warn('window.jt 不存在，无法调用原生 showToast')
  }
}

// 泰国外场销毁页面，返回上一页
export const registerPreviousH5 = async () => {
  dsBridge.register('previous', function (result: any) {
    // console.log('触发返回=====',result)
    const isApp = router.currentRoute.value.meta?.thOutfield
    const userInfoData = JSON.parse(localStorage.getItem('SandsTalkUserInfo') || '{}')
    if (isApp || userInfoData.sourceType === 'training') {
      // 首页或培训列表页
      destroyH5()
    } else {
      router.go(-1)
    }
  })
}

// 添加越南外场返回处理
export const registerVnPrevious = () => {
  window.previous = () => {
    const currentRoute = router.currentRoute.value
    // 如果是需要拦截返回的页面（比如有未保存的表单等），返回 false
    if (!currentRoute.meta?.isVnOutfield) {
      router.go(-1)
      return false
    }
    // 其他情况走原生返回逻辑
    return true
  }
}

export const getLangKey = (lang: string) => {
  switch (lang) {
    case 'zh':
      return 'zh-cn'
    case 'en':
      return 'en-us'
    case 'vn':
      return 'vi'
    default:
      return 'zh-cn'
  }
}
